// extracted by mini-css-extract-plugin
module.exports = {"flash-sale-countdown":"Countdown_flash-sale-countdown__kO5Do"};